import { createContext, useContext, useEffect, useState } from "react";

interface ScrollContext {
  scroll: number;
}

const ScrollContext = createContext<ScrollContext | null>(null);

export const ScrollProvider = ({ children }: { children: any }) => {
  const [scroll, seScroll] = useState<number>(0);

  const onScroll = () => {
    seScroll((state) => {
      if (state >= 1000) {
        return 0;
      } else {
        return state + 1;
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
  }, []);

  return (
    <ScrollContext.Provider value={{ scroll }}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScrollListener = () => {
  return useContext(ScrollContext) as ScrollContext;
};
